export const eventsNowLoaderScenarioId = 'CalendarSurface_EventsNowCalendarCacheId';
